<script>
import HelpIcon from './Shared/HelpIcon.vue';
import ReactiveMarker from './Shared/ReactiveMarker.vue';
import SelectAllMarker from './Shared/SelectAllMarker.vue';
import FundAllocator from './ListActions/FundAllocator';
import Archiver from '../../lib/components/ListActions/Archiver.vue';
import Unarchiver from '../../lib/components/ListActions/Unarchiver.vue';
import Deletism from '../../lib/components/ListActions/Deletism.vue';
import Undeletism from './ListActions/Undeletism';
import ListAction from './ListActions/ListAction';

/**
 * The DataTable component.
 *
 * Provides functionality to check/uncheck all rows.
 */
export default {
  components: {
    HelpIcon,
    ReactiveMarker,
    SelectAllMarker,
    ListAction,
    FundAllocator,
    Archiver,
    Unarchiver,
    Undeletism,
    Deletism,
  },
  props: {
    ids: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selected: []
    };
  },
  computed: {
    allChecked() {
      return this.selected.length === this.ids.length;
    }
  },
  watch: {
    selected() {
      this.$emit('update:selected', this.selected);
    }
  },
  methods: {
    checkAll() {
      this.selected = !this.allChecked ? this.ids.slice() : [];
    }
  }
};
</script>
